import React from "react"
import { graphql, navigate } from "gatsby"
import Link from "gatsby-link"

import { ArticleTeaserFieldsFragment } from "../../graphql-types"

export const query = graphql`
  fragment ArticleTeaserFields on DatoCmsArticle {
    id
    key
    title
    articleType
    publishedDate(formatString: "MMMM DD, YYYY")
    categories {
      id
      name
    }
    image {
      url(imgixParams: { w: "800", fm: "jpg" })
    }
    path: gatsbyPath(filePath: "/articles/{DatoCmsArticle.key}")
  }
`

interface ArticleTeaserProps {
  article: ArticleTeaserFieldsFragment
}

const ArticleTeasers: React.FC<ArticleTeaserProps> = ({ article }) => {
  const imageUrl = (article.image && article.image.url) || ""
  const path = `/articles/${article.key}/`

  return (
    <div className="c-article-teaser" onClick={() => navigate(path)}>
      <div className="c-article-teaser__img-holder">
        <div
          className="c-article-teaser__img"
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundPosition: "bottom center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      </div>
      <div className="c-article-teaser__content">
        <p className="c-article-teaser__date">{article.publishedDate}</p>
        <h3 className="c-preamble">
          <Link to={path}>{article.title}</Link>
        </h3>
      </div>
    </div>
  )
}

export default ArticleTeasers
